import * as React from 'react';
import { Platform, StyleSheet, Text, TextProps } from 'react-native';
import PlatformColor from './PlatformColor';
import useDialogTheme, { StyleBuilder } from './useTheme';

export type DialogDescriptionProps = TextProps;

const DialogDescription: React.FC<DialogDescriptionProps> = props => {
  const { style, children, ...nodeProps } = props;
  const { styles } = useDialogTheme(buildStyles);

  return (
    <Text style={[styles.text, style]} {...nodeProps}>
      {children}
    </Text>
  );
};

DialogDescription.displayName = 'DialogDescription';

const buildStyles: StyleBuilder = isDark =>
  StyleSheet.create({
    text: Platform.select({
      default: {
        textAlign: 'center',
        color: PlatformColor('label'),
        fontSize: 13,
        marginTop: 4,
      },
      android: {
        color: PlatformColor(
          `@android:color/${
            isDark ? 'secondary_text_dark' : 'secondary_text_light'
          }`,
        ),
        fontSize: 16,
        marginTop: 10,
      },
    }),
  });

export default DialogDescription;
